<template>
  <div class="login-container">
      <div class="title-container">
        <img src="https://al3.acc5.com/179227_62a98518324c00.png">
      </div>
      <div class="progress">
        <div :class="'progress-bar ' +classRad" :style="'width:' +percentage+'%'">
          <div class="progress-value">{{percentage}}%</div>
        </div>
      </div>
      <p class="login-text">扫码成功，系统正在跳转中...</p>
      <el-link href="/"  ><el-button type="primary">登录失败？返回登录</el-button></el-link>
  </div>
</template>
<script>
import { generateCode,doLogin,verifyUser } from "@/api/user";
export default {
  data() {
    return {
      class:["a","b","c","d"],
      classRad:"",
      percentage:0,
      timer:null
    }
  },
  created () {
    this.classRad = this.class[parseInt(Math.random()*this.class.length,10)]
    this.timer = setInterval(()=>{
      if(this.percentage < 99){
        this.percentage += 1
      }else{
        clearInterval(this.timer)
      }
    },20)
  },
  methods: {
    //验证 是否存在有效用户！
    doVerifyUser(){
    },
  }
}
</script>
<style scoped>
.login-container{position: absolute;left: 0;bottom: 0;top: 0;right: 0; background-image: url(https://al3.acc5.com/179227_62a985187aa310.png);background-size: cover;}
.login-container .title-container{padding-top: 4%;}
.login-text{
  font-size: 22px;
  color:#fff;
}
.progress {
    width: 60%;
    margin: 0 auto;
    background: #262626;
    border-radius: 20px;
    height: 20px;
    overflow: visible;
}
.progress-bar.a{
  background: linear-gradient(to right, #e39f86 35%,#b0ba90 68%);
}
.progress-bar.b{
  background: linear-gradient(to right, #da81a1 35%,#7aa4c8 68%);
}
.progress-bar.c{
  background: linear-gradient(to right, #cc5345 35%,#ff7f36 68%);
}
.progress-bar.d{
 background: linear-gradient(to right, #00b360 35%,#ffb036 68%);
}
.progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
}
.progress .progress-bar {
    border-radius: 20px;
    position: relative;
}
.progress .progress-value {
    display: block;
    font-size: 13px;
    color: #fff;
    border-radius: 4px;
    padding: 3px 8px;
    background: #191919;
    position: absolute;
    top: -40px;
    right: -27px;
}
.progress .progress-value:after {
    content: "";
    border-top: 5px solid #191919;
    border-left: 5px solid #191919;
    border-bottom: 5px solid transparent;
    border-right: 5px solid transparent;
    position: absolute;
    bottom: -6px;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/complete/index.vue